import styled from '@emotion/styled';

export const SContainer = styled.div``;

export const SControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px;
  align-items: center;
`;
